module.exports = __webpack_public_path__ + "img/products_big_can_cherry_ru.77a0b50f.png";